var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2538 80.6028C15.0541 79.5491 13.9095 78.4341 12.8249 77.263C12.3704 76.772 11.9264 76.2711 11.4936 75.7603C4.70754 67.7574 0.615234 57.3984 0.615234 46.0835C0.615234 20.7247 21.173 0.166992 46.5318 0.166992C71.8905 0.166992 92.4483 20.7247 92.4483 46.0835C92.4483 57.3985 88.3559 67.7574 81.5698 75.7603C81.137 76.2711 80.6929 76.772 80.2385 77.263C79.1539 78.4341 78.0093 79.5491 76.8096 80.6028H16.2538Z",
    fill: "#F7F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8097 80.6027C68.7269 87.6979 58.1311 91.9999 46.5318 91.9999C34.9324 91.9999 24.3366 87.698 16.2539 80.6027C23.0529 69.8102 34.0815 62.793 46.5318 62.793C58.9821 62.793 70.0106 69.8104 76.8097 80.6027Z",
    fill: "#272727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5315 55.1187C56.7738 55.1187 65.0767 46.8158 65.0767 36.5735C65.0767 26.3313 56.7738 18.0283 46.5315 18.0283C36.2893 18.0283 27.9863 26.3313 27.9863 36.5735C27.9863 46.8158 36.2893 55.1187 46.5315 55.1187Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.45b78947ba921249e8e115c4807c09ff.svg";
export { ForwardRef as ReactComponent };